import { useState, useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// @mui
import {
  Box,
  Button,
  Card,
  Stack,
  Typography,
  Tooltip,
  IconButton,
} from '@mui/material';
// components
import Avatar from '../../components/Avatar';
import Scrollbar from '../../components/Scrollbar';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
import {
  FliersDetailDialog,
} from './';
// routes
import { PATH_SCOUT } from '../../routes/paths';

const TooltipContent = () => {
  return (
    <Box sx={{ maxWidth: "100%", width: 350 }}>
      <Typography variant="subtitle2">
        파트타임 제안은 크루가 커피챗을 수락해야 진행할 수 있어요.
      </Typography>
      <Typography variant="body2">
        크루가 아직 응답 대기중이거나,<br/>커피챗을 거절했다면 파트타임 제안을 진행할 수 없습니다.
      </Typography>
    </Box>
  )
}

// ----------------------------------------------------------------------

export default function CoffeeChatList({ coffeeChats, reload }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Scrollbar>
      <Tooltip
        open={tooltipOpen}
        title={<TooltipContent />}
        placement="bottom"
        arrow
        disableFocusListener
        disableHoverListener
        onOpen={() => setTooltipOpen(true)}
        onClose={() => setTooltipOpen(false)}
        componentsProps={{
          tooltip: {
            sx: {
              p: 1,
              width: 350,
              maxWidth: "none",
            },
          }
        }}
      >
        <Button
          startIcon={<Iconify icon="eva:info-fill" />}
          sx={{ color: "text.secondary" }}
          onClick={() => setTooltipOpen(true)}
        >
          파트타임 제안은 언제할 수 있나요?
        </Button>
      </Tooltip>
      <Stack
        spacing={2}
        sx={{ p: 0.2, pb: 5, }}
      >
        {coffeeChats && coffeeChats.map((row, index) => (
          <CoffeeChatListItem
            key={index}
            row={row}
            reload={reload}
          />
        ))}
      </Stack>
    </Scrollbar>
  )
}

// ------

const positionLabel = {
  "developer": "개발자",
  "designer": "디자이너",
  "marketer": "마케터",
  "engineer": "하드웨어 엔지니어",
  "product-manager": "설계 / 기획 / 관리",
  "data-analysis": "데이터분석",
  "finance": "재무 • IR/투자 전문가",
  "operator": "CS • 오퍼레이터",
};

const statusLabel = {
  "wait": "진행전",
  "offer-to-crew": "커피챗 제안 보냄",
  "offer-to-company": "커피챗 일정 확정하기",
  "other-time-requested": "다른 일정 요청함",
  "crew-decline": "크루의 커피챗 거절",
  "company-decline": "중단",
  "meeting-selected": "커피챗 일정 선택함",
  "meeting-confirmed": "커피챗 일정 확정",
  "meeting-done": "파트타임 제안 가능",
};

function CoffeeChatListItem({
  row,
  reload,
}) {
  const { query, push } = useRouter();
  const [isOpenFliersDetailDialog, setIsOpenFliersDetailDialog] = useState(false);
  const greyStatus = row.coffee_chat_status === "wait" || row.coffee_chat_status === "crew-decline" || row.coffee_chat_status === "company-decline";

  const {
    crew,
    coffee_chat_status,
  } = row;

  const {
    nickname,
    position,
    randomhash,
  } = crew;

  useEffect(() => {
    if (query && query.cid && query.cid == row?.id) {
      setIsOpenFliersDetailDialog(true);
      push(PATH_SCOUT.manage, undefined, { shallow: true });
    }
  }, [query]);

  return (
    <Card
      onClick={(e) => {
        e.stopPropagation();
        setIsOpenFliersDetailDialog(true);
      }}
      sx={{ p: 3 }}
    >
      <Stack direction="row" justifyContent="space-between">
        <Stack
          spacing={1}
          direction="row" alignItems="flex-start"
          sx={{ overflow: 'hidden' }}
        >
          <Avatar
            src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${randomhash || '5'}.png`}
            alt={nickname}
            sx={{
              width: 32,
              height: 32,
            }}
          />
          <Stack spacing={1} sx={{ overflow: 'hidden' }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="subtitle2" noWrap sx={{ textOverflow: 'ellipsis' }}>
                {nickname}
              </Typography>
              <Typography variant="caption" noWrap sx={{ minWidth: "45px", color: "text.secondary" }}>
                {positionLabel?.[position]}
              </Typography>
            </Stack>
            <Box>
              <Label
                color={greyStatus ? "default" : "info"}
                variant={greyStatus ? "ghost" : "filled"}
              >
                {statusLabel?.[coffee_chat_status]}
              </Label>
            </Box>
          </Stack>
        </Stack>
        <IconButton edge="end">
          <Iconify icon="ic:chevron-right" />
        </IconButton>
      </Stack>
      <FliersDetailDialog
        isOpen={isOpenFliersDetailDialog}
        closeDialog={() => { setIsOpenFliersDetailDialog(false) }}
        reload={reload}
        coffeeChat={row}
      />
    </Card>
  );
}
